/**
 * Footer — shown on every page of Inbox.
 */

import React from 'react';

export default function Footer() {
  return (
    <footer style={styles.footer}>
      <p style={styles.text}>Inbox © 2025 — Private & Confidential</p>
    </footer>
  );
}

const styles = {
  footer: {
    borderTop: '1px solid #D0DAE6',
    background: '#FFFFFF',
    padding: '1rem 1.5rem',
    marginTop: 'auto',
    textAlign: 'center',
  },
  text: {
    fontSize: '0.75rem',
    color: '#6B7A8D',
    margin: 0,
  },
};
